
export const SarApplicationGroupConstant = {
    SARGroup: 'api/Group',  
    SARGroupRoute: 'SARApplicationGroup',
    ManageSARGroupRoute: 'manageSARApplicationGroup' ,
    bulkInsertMessage:'SAR Application Groups are successfully importd',
    searchFieldName: 'name',
};